import React from 'react';
import { RouterProvider, createBrowserRouter, redirect } from 'react-router-dom';

import { config } from '_config';

import App from 'components/app/App';
import MainLayout from 'components/app/layouts/MainLayout';
import PrivateLayout from 'components/app/layouts/PrivateLayout';
import PublicLayout from 'components/app/layouts/PublicLayout';
import BillingPage from 'components/pages/BillingPage';
import ErrorBoundaryPage from 'components/pages/ErrorBoundaryPage';
import ForgotPasswordPage from 'components/pages/ForgotPasswordPage';
import LoginPage from 'components/pages/LoginPage';
import LogoutPage from 'components/pages/LogoutPage';
import MDChatPage from 'components/pages/MDChatPage';
import OrderDetailsPage from 'components/pages/OrderDetailsPage';
import ProfilePage from 'components/pages/ProfilePage';
import QuestionnairePage from 'components/pages/QuestionnairePage';
import ResetPasswordPage from 'components/pages/ResetPasswordPage';
import SubscriptionsPage from 'components/pages/SubscriptionsPage';

import PrivateRoute from './PrivateRoute';
import PublicRoute from './PublicRoute';

const routes = [
  {
    path: config.publicUrl,
    element: <App />,
    errorElement: <ErrorBoundaryPage />,
    children: [
      {
        element: <PrivateRoute />,
        children: [
          {
            element: <PrivateLayout />,
            children: [
              {
                path: 'account',
                element: <MainLayout />,
                children: [
                  { path: '', loader: () => redirect('subscriptions') },
                  { path: 'profile', element: <ProfilePage /> },
                  { path: 'billing', element: <BillingPage /> },
                  { path: 'subscriptions', element: <SubscriptionsPage /> },
                  { path: 'order/:orderId', element: <OrderDetailsPage /> },
                  { path: 'order/:orderId/chat', element: <MDChatPage /> },
                  { path: 'order/:orderId/questionnaire', element: <QuestionnairePage /> },
                ],
              },
              {
                path: 'logout',
                element: <LogoutPage />,
              },
            ],
          },
        ],
      },
      {
        element: <PublicRoute />,
        children: [
          {
            element: <PublicLayout />,
            children: [
              { path: '', loader: () => redirect('login') },
              { path: 'login', element: <LoginPage /> },
              { path: 'forgot-password', element: <ForgotPasswordPage /> },
              { path: 'reset-password', element: <ResetPasswordPage /> },
            ],
          },
        ],
      },
    ],
  },
  { path: '*', loader: () => redirect(config.publicUrl) },
];

export const router = createBrowserRouter(routes);

const Routes = () => <RouterProvider router={router} />;

export default Routes;
